import React from 'react';
import NewApplicationHOC from '../../containers/newApplicationHOC'
import OverviewTabHOC from '../../containers/ApplicationTabs/overviewTabHOC';
import PolicyTabHOC from "../../containers/policyTabHOC";
import DocumentsTabHOC from '../../containers/ApplicationTabs/documentsTabHOC'
import UpdateTabHOC from '../../containers/ApplicationTabs/updateTabHOC';
import GeneralSVG from "../generalSVG";
import moment from "moment/moment";
import AdvancedDisbursementsTabHOC from "../../containers/ApplicationTabs/advancedDisbursementsTabHOC";
import PendingChangesTabHOC from "../../containers/ApplicationTabs/pendingChangesTabHOC";
import Popover from "../General/popover";
import FormGroupPlainText from "../formGroupPlainText";

const ApplicationPolicyPageContent = (props) => {
    let userRole = props.User.loggedInUser.roles[0];
    let attachments = [];
    let rowData = [];
    if (props.SavedApplicationAttachments.length > 0) {
        attachments = props.SavedApplicationAttachments
    }
    else attachments = [];
    let value;
    let Label;
    for (let i = 0; i < attachments.length; i++) {
        Label = <div>
            <p className="applicationPolicy-paragraph textBold">{attachments[i].fullName}</p>
            <p className="applicationPolicy-paragraph">{moment(attachments[i].addedAt).format('DD/MM/YYYY - HH:mm:ss')}</p>
        </div>;
        value = <div className="">
            <span className="col-sm-12">
                {attachments[i].name}
            </span>
            <div className="">
                <div className="col-sm-2">
                    <a onClick={() => { props.requestApplicationAttachment({ applicationId: props.selectedApplication.id, attachmentId: attachments[i].id, relativeUrl: attachments[i].relativeUrl }); }}
                        className="applicationPolicy-document-tab-link">
                        <GeneralSVG
                            SvgWrapper="generalTab-download-wrapper"
                            Label="Download"
                            Svg={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><title>Asset 9</title>
                                <g id="Layer_2" data-name="Layer 2">
                                    <g id="info">
                                        <path
                                            d="M9.5,6a.5.5,0,0,0-.5.5V9H1V6.5a.5.5,0,0,0-1,0V10H10V6.5A.5.5,0,0,0,9.5,6Z"/>
                                        <path
                                            d="M5,7.21,7.35,4.85a.5.5,0,0,0-.71-.71L5.5,5.29V0h-1V5.29L3.35,4.15a.5.5,0,0,0-.71.71Z"/>
                                    </g>
                                </g>
                            </svg>}
                        />
                    </a>
                </div>
                {
                    (userRole !== 'Solicitor' && props.SelectedApp.policyStatus !== 'Rejected') ?
                        <div className="col-sm-2">
                            <FormGroupPlainText
                                Text={
                                    <Popover
                                        title={'Are you sure?'}
                                        onAccept={(evt) => {
                                            props.RequestDeleteDocument(props.SelectedApp.id, attachments[i].id, attachments[i].relativeUrl);
                                        }}><GeneralSVG
                                            SvgWrapper="generalTab-readMore-wrapper applicationPolicy-document-delete-wrapper"
                                            Label={'Delete'}
                                            Svg={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.6 16"><title>Asset 2</title>
                                                <g id="Layer_2" data-name="Layer 2">
                                                    <g id="Layer_1-2" data-name="Layer 1">
                                                        <path
                                                            d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                                    </g>
                                                </g>
                                            </svg>}
                                        />
                                    </Popover>
                                }
                            />
                        </div>
                        :
                        null
                }
            </div>
        </div>;
        rowData.push({
            key: Label,
            value: value
        })
    }
    return (
        <div className="row">
            {
                (props.Store.activeTab === 'application') ?
                    <div className="col-sm-12">
                        <NewApplicationHOC />
                    </div>
                    :
                    null
            }
            {
                (props.Store.activeTab === 'overview') ?
                    <OverviewTabHOC
                        applicationStatus={props.SelectedApp.policyStatus}
                        ApplicationPolicyStore={props.Store}
                        CheckUserOverviewTabCheckBox={props.CheckUserOverviewTabCheckBox}
                        UserRole={userRole}
                        PageShift={props.PageShift}
                        CalculateFeaturedOverview={props.CalculateFeaturedOverview}
                        ChangeOverViewTabReadMoreState={props.ChangeOverViewTabReadMoreState}
                        RowData={[]}
                        Label="overview"
                        HandleInputChange={props.handleOverviewInputChange}
                        handleSubmit={props.handleOverviewTabSubmit}
                        overviewTab={props.overviewTab}
                        OnDrop={props.OnDropOverview}
                        requestApplicationAttachment = {props.requestApplicationAttachment}
                    />
                    :
                    null
            }
            {
                (props.Store.activeTab === 'documents') ?
                    <DocumentsTabHOC
                        fetchingAllApplicationAttachments={props.newApplication.fetchingAllApplicationAttachments}
                        RowData={rowData}
                        Label="documents"/>
                    :
                    null
            }
            {
                (props.Store.activeTab === 'update') ?
                    <UpdateTabHOC
                        SelectedAppId={props.SelectedApp.id}
                        applicationStatus={props.SelectedApp.policyStatus}
                        UserRole={userRole}
                    />
                    :
                    null
            }
            {
                (props.Store.activeTab === 'policySchedule') ?
                    <PolicyTabHOC
                        match={props.match}
                        router={props.router}
                        selectedApp={props.SelectedApp}
                    />
                    :
                    null
            }
            {
                (props.Store.activeTab === 'advancedDisbursements') ?
                    <AdvancedDisbursementsTabHOC
                        _openAdvancedDisbursementsApplicationModal={props._openAdvancedDisbursementsApplicationModal}
                        User={props.User}
                    />
                    :
                    null
            }
            {props.Store.activeTab === 'pendingChanges' && (<PendingChangesTabHOC/>)}
        </div>
    )
};

export default ApplicationPolicyPageContent;